var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.2812C8.53125 18.2812 9.375 17.4375 9.375 16.4062H5.625C5.625 17.4375 6.46875 18.2812 7.5 18.2812ZM13.125 12.6562V7.96875C13.125 5.09062 11.5969 2.68125 8.90625 2.04375V1.40625C8.90625 0.628125 8.27812 0 7.5 0C6.72188 0 6.09375 0.628125 6.09375 1.40625V2.04375C3.4125 2.68125 1.875 5.08125 1.875 7.96875V12.6562L0 14.5312V15.4687H15V14.5312L13.125 12.6562ZM11.25 13.5937H3.75V7.96875C3.75 5.64375 5.16563 3.75 7.5 3.75C9.83438 3.75 11.25 5.64375 11.25 7.96875V13.5937Z",
    fill: "#2B3E5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.aa6aa8c76c931c84e79f166c12339b26.svg";
export { ForwardRef as ReactComponent };